import GjwSearchForm from './src/GjwSearchForm'

GjwSearchForm.install = function(Vue) {
  Vue.component(GjwSearchForm.name, GjwSearchForm)
}

export default GjwSearchForm
